import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/report';

const extractNameOfFileFromHeader = (headers)=> {
  let fileName;
  const contentDisposition = headers['content-disposition'];

  if(contentDisposition && contentDisposition.indexOf('attachment') !== -1){
    const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/, matches = regex.exec(contentDisposition);
    if(matches != null && matches[1]) fileName = matches[1].replace(/['"]/g, '');
  }

  return fileName;
};

const apiGenerateExcelReport = async (req)=> new Promise((resolve, reject)=> axiosConsumer().post(`${resource}/generate`, req, { responseType: 'arraybuffer' })
  .then((res)=> resolve({ name: extractNameOfFileFromHeader(res.headers), data: res.data }))
  .catch((e)=> reject(e.response.data)));
const downloadGeneratedFileReport = (file)=> {
  const url = window.URL.createObjectURL(new Blob([ file.data ])), link = document.createElement('a');
  link.href = url; link.setAttribute('download', file.name);
  document.body.appendChild(link);
  link.click();
};

export const ReportRepository = {
  generate: apiGenerateExcelReport,
  download: downloadGeneratedFileReport
};